<template>
	<div>
		<h1>Validation ONP</h1>


		<div v-if="!code_postal">
			Il n'y a pas de changement pour le moment.
		</div>
		<div v-else>
			<b-select @change="set" v-model="code_postal" :options="codes_postal"></b-select>
		</div>

		<div v-show="actual_pharmacie">
			<h3>Pharmacies actives dans la base de données</h3>

			<edit_tabulator ref="actual_pharmacie" :extern_file="false"></edit_tabulator>

			<b-button variant="link" v-b-toggle="'pharmaciens'">Pharmaciens actifs dans la base de données</b-button>
			<b-button variant="link" v-b-toggle="'unactive_pharmacies'">Pharmacies désactivées</b-button>
			<br /><br />

			<b-collapse id="pharmaciens">
				<edit_tabulator ref="actual_pharmaciens" :extern_file="false"></edit_tabulator>
			</b-collapse>
			

			<b-collapse id="unactive_pharmacies">
				<edit_tabulator ref="unactive_pharmacies" :extern_file="false"></edit_tabulator>
			</b-collapse>
		</div>

		<div v-if="pharmacie">
			<h3>Modification</h3>
		</div>

		<div v-for="(data, idx) in change"  :key="idx">
			<div v-if="idx == 0 || change[idx - 1].id_pharmacie_onp != data.id_pharmacie_onp">
				<b-button variant="link" @click="visibility(data.id_pharmacie_onp)">{{data.id_pharmacie}}</b-button>
				<b-button variant="link" @click="update_status(null, 'validé', data.id_pharmacie_onp)"><i style="color:green" class="fa fa-check"></i></b-button>&nbsp;
				<b-button variant="link" @click="update_status(null, 'refusé', data.id_pharmacie_onp)"><i style="color:red" class="fas fa-times"></i></b-button>&nbsp;
				<b-button variant="link" @click="update_status(null, 'erreur', data.id_pharmacie_onp)"><i style="color:black" class="fas fa-exclamation-triangle"></i></b-button>
				<br />
				Etat : {{data.status == "créé" ? "En attente" : data.status}}
			</div>
			<b-card v-show="data.visible">
				<div v-if="data.update_table == 'pharmacie'">
					<div v-if="data.type == 'insert'">
						<div>Ajout d'une pharmacie</div>
						<br />
						<div>Ancienne pharmacie pour transfert des informations</div>
						<b-select @change="set_sub_type(idx)" v-model="data.transfert" :options="options_transfert"></b-select>
						<div v-if="data.transfert" style="margin-top: 10px;margin-bottom: 10px">
							<b-button @click="set_transfert_columns(idx, onp_colonnes, 'même pharmacie')" :variant="data.sub_type == 'même pharmacie' ? 'primary' : 'outline-primary'">même pharmacie</b-button>&nbsp;
							<b-button @click="set_transfert_columns(idx, onp_colonnes_transfert, 'transfert')" :variant="data.sub_type == 'transfert' ? 'primary' : 'outline-primary'">transfert</b-button>&nbsp;
							<b-button @click="set_transfert_columns(idx, onp_colonnes_reprise, 'reprise')" :variant="data.sub_type == 'reprise' ? 'primary' : 'outline-primary'">reprise</b-button>
							<b-button v-b-toggle="'transfert'" variant="link">Personnaliser les colonnes</b-button>
						</div>
						<b-collapse id="transfert">
							<b-button @click="set_transfert_columns(idx, onp_colonnes, 'même pharmacie')" variant="link">Toutes les colonnes</b-button>
							<b-button @click="set_transfert_columns(idx, [], '')" variant="link">Aucunne colonne</b-button>
							<b-button @click="set_transfert_columns(idx, onp_colonnes_transfert, 'transfert')" variant="link">Transfert</b-button>
							<b-button @click="set_transfert_columns(idx, onp_colonnes_reprise, 'reprise')" variant="link">Reprise</b-button>
							<b-button @click="set_transfert_columns(idx, onp_colonnes_reprise_siret, 'reprise')" variant="link">Reprise avec Siret</b-button>
							<br />
							<div style="display:inline-block; width:280px" v-for="(column, key) in data.transfert_columns" :key="'t' + key">
								<b-checkbox style="display:inline" v-model="data.transfert_columns[key]"></b-checkbox>{{key}}
							</div>
						</b-collapse>
						<div v-for="(value, key) in data.values_update" :key="key">
							<div v-if="['id_pharmacie_onp', 'identifiant', 'raison_sociale', 'adresse', 'ville', 'code_postal', 'active', 'denomination', 'telephone', 'telecopie'].includes(key)">
								<b>{{key}}</b> : {{ value }}
							</div>
							<div v-else-if="typeof value == 'object'">
								<b>{{key}}</b> : <b-input style="display: inline-block; max-width:500px" v-model="value.after" /> <span style="opacity:0.5; color: red">{{ data.transfert ? actual_pharmacies_obj[data.transfert][key] : ""}}</span>
							</div>
							<div v-else>
								<b>{{key}}</b> : <b-input style="display: inline-block; max-width:500px" v-model="data.values_update[key]" />
							</div>
						</div>
						Autres colonnes : <b-select style="display: inline-block; max-width:200px" v-model="data.insert_column" @change="set_new_column(data, data.values_update, data.insert_column, {after: data.transfert ? actual_pharmacies_obj[data.transfert][data.insert_column] : ''})" :options="onp_colonnes.filter((value) => !Object.keys(data.values_update).includes(value))"></b-select>
					</div>
					<div v-else-if="data.type == 'unactive'">
						<div>Désactivation de la pharmacie</div>
					</div>
					<div v-else>
						<div>Modification de la pharmacie</div>
						<br />
						<b-button @click="set_transfert_columns(idx, onp_colonnes, 'même pharmacie')" :variant="(data.sub_type == 'même pharmacie' || !data.sub_type) ? 'primary' : 'outline-primary'">même pharmacie</b-button>&nbsp;
						<b-button @click="set_transfert_columns(idx, onp_colonnes_transfert, 'transfert')" :variant="data.sub_type == 'transfert' ? 'primary' : 'outline-primary'">transfert</b-button>&nbsp;
						<b-button @click="set_transfert_columns(idx, onp_colonnes_reprise, 'reprise')" :variant="data.sub_type == 'reprise' ? 'primary' : 'outline-primary'">reprise</b-button>
						<br />
						<br />
						<div v-for="(value, key) in data.values_update" :key="key">
							<div v-if="['id_pharmacie_onp', 'identifiant', 'raison_sociale', 'adresse', 'ville', 'code_postal', 'active', 'denomination', 'telephone', 'telecopie'].includes(key)">
								<b>{{key}}</b> : {{ value.after }} <span style="opacity:0.5; color: red">{{ actual_pharmacies_obj[data.value_id][key]}}</span>
							</div>
							<div v-else>
								<b>{{key}}</b> : <b-input style="display: inline-block; max-width:500px" v-model="value.after" /> <span style="opacity:0.5; color: red">{{ actual_pharmacies_obj[data.value_id][key]}}</span>
							</div>
						</div>
						Autres colonnes : <b-select style="display: inline-block; max-width:200px" v-model="data.new_column" @change="set_new_column(data, data.values_update, data.new_column, {after: actual_pharmacies_obj[data.value_id][data.new_column]})" :options="onp_colonnes.filter((value) => !Object.keys(data.values_update).includes(value))"></b-select>
					</div>
				</div>
				<div v-else>
					<div v-if="data.type == 'insert'">
						<div>Ajout d'un pharmacien</div>
						<br />
						<div v-for="(value, key) in data.values_update" :key="key">
							<b>{{key}}</b> : {{ value }}
						</div>
					</div>
					<div v-else-if="data.type == 'unactive'">
						<div>Désactivation du pharmacien {{actual_pharmaciens_obj[data.value_id].prenom}} {{actual_pharmaciens_obj[data.value_id].nom}}<br />{{ actual_pharmaciens_obj[data.value_id].statut }}</div>
					</div>
					<div v-else>
						<div>Modification du pharmacien {{data.value_id}}</div>
						<br />
						<div v-for="(value, key) in data.values_update" :key="key">
							<b>{{key}}</b> : {{ value.after }} <span style="opacity:0.5; color: red">{{ value.before }}</span>
						</div>
					</div>
				</div>
			</b-card>
		</div>

		<div v-if="code_postal">
			<br />
			<b-button variant="success" @click="update_status(null, 'validé')">Tout valider</b-button>&nbsp;
			<b-button variant="danger" @click="update_status(null, 'refusé')">Tout refuser</b-button>&nbsp;
			<b-button variant="" @click="update_status(null, 'erreur')">Tout mettre en erreur</b-button>
			<br /><br />
			<b-button @click="send" :disabled="nb_wait > 0 ? true: false">Enregistrer</b-button>
		</div>
	</div>
</template>

<script>
	import store from "../../store"
	import treatments from "../../services/treatments.js";
	import edit_tabulator from "../../components/edit_tabulator.vue";

	const json2csv = require("json2csv").parse;
	var clone = require("clone");

    import users from "../../services/users.js";
    import database from "../../services/database.js";

	export default {
		components: {
			edit_tabulator
		},
		data() {
			return {
				options_transfert: [
					{ value: "", text: '' },
					 {
						label: 'Pharmacies en cours de désactivation',
						options: [
						]
					 },
					 {
						label: 'Pharmacies désactivées',
						options: [
						]
					 },
					 {
						label: 'Pharmacies actives',
						options: [
						]
					 }
				],
				unactive_pharmacies: [],
				pharmacies: [],
				pharmacie: "",
				code_postal: "",
				codes_postal: [],
				actual_pharmacie: null,
				actual_pharmacies_obj: {},
				actual_pharmaciens: [],
				actual_pharmaciens_obj: {},
				change: [],
				nb_wait: 0,

				onp_colonnes: [],
				onp_colonnes_reprise: [],
				onp_colonnes_transfert: [],
				onp_colonnes_reprise_siret: []
			};
		},
		methods: {
			request_insert(table, obj)
			{
				//console.log(obj)
				var columns = "";
				var values = "";
				
				var keys = Object.keys(obj);
				for (var i = 0; i < keys.length; i++)
				{
					var value = obj[keys[i]];
					if (typeof value == 'object')
						value = value.after;
					if (!value)
						value = "";
					if (i > 0)
					{
						columns += ",",
						values += ",";
					}
					columns += keys[i];
					values += "'" + value.replace(/'/g, "\\'").replace(/\"/g, '\\"') + "'";
				}
				
				var str = "INSERT INTO " + table + " (" + columns + ") VALUES (" + values + ")";
				
				return str;
			},

			request_update(table, column, value_id, obj, column2, value2)
			{
				var str = "UPDATE " + table + " SET ";

				var keys = Object.keys(obj);
				for (var i = 0; i < keys.length; i++)
				{
					var value = obj[keys[i]];
					if (typeof value == 'object')
						value = value.after;
					if (!value)
						value = "";
					if (i > 0)
					{
						str += ",";
					}
					str += keys[i] + "='" + value.replace(/'/g, "\\'").replace(/\"/g, '\\"') + "'";
				}
				
				str += " WHERE BINARY " + column + " = '" + value_id.replace(/'/g, "\\'").replace(/\"/g, '\\"') + "'";
				if (column2)
					str += " AND BINARY " + column2 + " = '" + value2.replace(/'/g, "\\'").replace(/\"/g, '\\"') + "'";
				
				return str;
			},
			request_del(table, column, value, column2, value2)
			{
				var str = "DELETE " + table + " WHERE BINARY " + column + " = " + value.replace(/'/g, "\\'").replace(/\"/g, '\\"') + "";
				if (column2)
					str += " AND BINARY " + column2 + " = '" + value2.replace(/'/g, "\\'").replace(/\"/g, '\\"') + "'";
				
				return str;
			},
			visibility(id_pharmacie_onp)
			{
				for (var i = 0; i < this.change.length; i++)
				{
					if (this.change[i].id_pharmacie_onp == id_pharmacie_onp)
					{
						this.$set(this.change[i], "visible", this.change[i].visible ? false : true);
						var status = this.change[i].status;
						this.$set(this.change[i], "status", "");
						this.$set(this.change[i], "status", status);
					}
				}
			},
			async update_status(idx, status, id_pharmacie_onp)
			{
				this.nb_wait = 0;
				if (idx)
				{
					this.$set(this.change[idx], "status", status);
				}
				for (var i = 0; i < this.change.length; i++)
				{
					if (!idx && (!id_pharmacie_onp || this.change[i].id_pharmacie_onp == id_pharmacie_onp))
					{
						this.$set(this.change[i], "visible", false);
						this.$set(this.change[i], "status", "");
						this.$set(this.change[i], "status", status);
					}
					if (this.change[i].status == "créé")
						this.nb_wait++;
				}
			},
			async send()
			{
				for (var i = 0; i < this.change.length; i++)
				{
					if (this.change[i].type == "insert")
						this.change[i].request = this.request_insert(this.change[i].update_table, this.change[i].values_update);
					else if (this.change[i].type == "update")
						this.change[i].request = this.request_update(this.change[i].update_table, this.change[i].colonne_id, this.change[i].value_id, this.change[i].values_update);
				}

				var str = json2csv(this.change, {
					fields: Object.keys(this.change[0]),
					fieldNames: Object.keys(this.change[0]),
					del: ",",
					quote: '"',
				});
				
				const bytes = new TextEncoder().encode(str);
				const blob = new Blob([bytes], {
					type: "text/plain",
				});

				await treatments
					.create(
						this.project,
						null,
						blob,
						"data.csv"
					).catch((err) => {
                    console.log("error : " + err);
                    this.$notify({
                        group: "info",
                        title: err.response.data.msg,
                        type: "error",
                    });
                });

				var index = this.codes_postal.indexOf(this.code_postal);
				if (index !== -1) {
					this.codes_postal.splice(index, 1);
				}
				if (this.codes_postal.length > 0)
				{
					if (index < this.codes_postal.length)
                        this.code_postal = this.codes_postal[index];
                    else
                        this.code_postal = this.codes_postal[index - 1];
					await this.set();
				}
				else
				{
					this.codes_postal = [];
					this.code_postal = "";
					this.pharmacies = [];
					this.pharmacie = "";
					this.actual_pharmacie = null;
					this.actual_pharmaciens = [];
					this.actual_pharmaciens_obj = {};
					this.change = [];
				}
			},
			async set_new_column(main, obj, key, value)
			{
				if (key)
				{
					this.$set(obj, key, value);
					if (main.transfert_columns)
						this.$set(main.transfert_columns, key, false);
				}
			},
			async set()
			{
				this.options_transfert = [
					{ value: "", text: '' },
					{
						label: 'Pharmacies en cours de désactivation',
						options: [
						]
					},
					{
						label: 'Pharmacies désactivées',
						options: [
						]
					},
					{
						label: 'Pharmacies actives',
						options: [
						]
					}
				];

				this.actual_pharmacies_obj = {};

				var pharmacies = await database.get("select", "pharmacie", {
					select: "*",
					where: "active = 1 && code_postal = \"" + this.code_postal + "\" order by identifiant"
				});

				for (var i = 0; i < pharmacies.length; i++)
				{
					this.options_transfert[3].options.push({value: pharmacies[i].id_pharmacie_onp, text: pharmacies[i].identifiant});
					this.actual_pharmacies_obj[pharmacies[i].id_pharmacie_onp] = pharmacies[i];
				}

				var unactive_pharmacies = await database.get("select", "pharmacie", {
					select: "*",
					where: "active = 0 && code_postal = \"" + this.code_postal + "\" order by identifiant"
				});

				for (var i = 0; i < unactive_pharmacies.length; i++)
				{
					this.options_transfert[2].options.push({value: unactive_pharmacies[i].id_pharmacie_onp, text: unactive_pharmacies[i].identifiant});
					this.actual_pharmacies_obj[unactive_pharmacies[i].id_pharmacie_onp] = unactive_pharmacies[i];
				}

				if (pharmacies.length > 0)
				{
					this.actual_pharmacie = pharmacies;
					this.$refs.actual_pharmacie.set_data(this.actual_pharmacie);
				}
				else
				{
					this.actual_pharmacie = [];
					this.$refs.actual_pharmacie.set_data(this.actual_pharmacie);
				}

				this.actual_pharmaciens_obj = {};
				this.actual_pharmaciens = await database.get("select", "pharmacien", {
					select: "*",
					where: "active = 1 && code_postal = \"" + this.code_postal + "\" order by pharmacie"
				});

				for (var i = 0; i < this.actual_pharmaciens.length; i++)
				{
					this.actual_pharmaciens_obj[this.actual_pharmaciens[i].id] = this.actual_pharmaciens[i];
				}

				this.$refs.actual_pharmaciens.set_data(this.actual_pharmaciens);

				var change = await database.get("select", "update_table", {
					select: "*",
					where: "code_postal = \"" + this.code_postal + "\" and status = 'créé' order by id_pharmacie, type, update_table"
				});

				//console.log("change")
				//console.log(this.change)

				this.nb_wait = change.length;
				for (var i = 0; i < change.length; i++)
				{
					change[i].new_column = "";
					//console.log(change[i].values_update)
					if (change[i].values_update)
						change[i].values_update = JSON.parse(change[i].values_update)
					change[i].visible = true;
					change[i].transfert = "";
					change[i].transfert_columns = {};
					change[i].sub_type = "";
					if (change[i].update_table == 'pharmacie' && change[i].type == 'unactive')
					{
						this.options_transfert[1].options.push({value: change[i].id_pharmacie_onp, text: change[i].id_pharmacie});
					}
					if (change[i].update_table == "pharmacie" && !this.actual_pharmacies_obj[change[i].value_id] && !change[i].colonne_id.includes(" "))
					{
						var _pharmacies = await database.get("select", "pharmacie", {
							select: "*",
							where: change[i].colonne_id + " = \"" + change[i].value_id + "\" order by identifiant"
						});
						if (_pharmacies && _pharmacies.length > 0)
						{
							this.options_transfert[3].options.push({value: _pharmacies[0].id_pharmacie_onp, text: _pharmacies[0].identifiant});
							this.actual_pharmacies_obj[_pharmacies[0].id_pharmacie_onp] = _pharmacies[0];
						}
					}
					if (change[i].update_table == "pharmacien" && !this.actual_pharmaciens_obj[change[i].value_id] && !change[i].colonne_id.includes(" "))
					{
						var pharmaciens = await database.get("select", "pharmacien", {
							select: "*",
							where: change[i].colonne_id + " = \"" + change[i].value_id + "\" order by identifiant"
						});
						if (pharmaciens && pharmaciens.length > 0)
						{
							this.actual_pharmaciens_obj[pharmaciens[0].id] = pharmaciens[0];
						}
					}
				}

				for (var i = 0; i < change.length; i++)
				{
					if (change[i].update_table == 'pharmacie' && change[i].type == 'insert')
					{
						for (var j = 0; j < this.onp_colonnes.length; j++)
						{
							change[i].transfert_columns[this.onp_colonnes[j]] = true;
						}
						for (var j = 0; j < unactive_pharmacies.length; j++)
						{
							if (unactive_pharmacies[j].adresse == change[i].values_update.adresse || unactive_pharmacies[j].raison_sociale == change[i].values_update.raison_sociale)
							{
								change[i].transfert = unactive_pharmacies[j].id_pharmacie_onp;
								change[i].sub_type = "même pharmacie";							
							}
						}

						for (var j = 0; j < pharmacies.length; j++)
						{
							if (pharmacies[j].adresse == change[i].values_update.adresse || pharmacies[j].raison_sociale == change[i].values_update.raison_sociale)
							{
								change[i].transfert = pharmacies[j].id_pharmacie_onp;
								change[i].sub_type = "même pharmacie";
							}
						}
					}
				}

				if (unactive_pharmacies.length > 0)
				{
					this.unactive_pharmacies = unactive_pharmacies;
					this.$refs.unactive_pharmacies.set_data(this.unactive_pharmacies);
				}
				else
				{
					this.unactive_pharmacies = [];
					this.$refs.unactive_pharmacies.set_data(this.unactive_pharmacies);
				}

				this.change = change;
			},
			set_sub_type(idx)
			{
				if (!this.change[idx].transfert)
					this.change[idx].sub_type = "";
				else if (!this.change[idx].sub_type)
				{
					this.change[idx].sub_type = "même pharmacie";
				}
				this.change = clone(this.change);
			},
			set_transfert_columns(idx, columns, sub_type)
			{
				//console.log(columns)

				var transfert_columns = {}
				var keys = Object.keys(this.change[idx].transfert_columns);
				for (var i = 0; i < keys.length; i++)
				{
					if (columns.includes(keys[i]))
						transfert_columns[keys[i]] = true;
					else
						transfert_columns[keys[i]] = false;
				}
				this.change[idx]["transfert_columns"] = transfert_columns;
				this.change[idx].sub_type = sub_type;
				this.change = clone(this.change)
			}
		},
		mounted: async function () {

			let response = await users.getSelf(true);
			let client = response.client;
			
			//console.log(client.details.var)

			this.onp_colonnes = client.details.var.onp_colonnes || [];
			this.onp_colonnes_reprise = client.details.var.onp_colonnes_reprise || [];
			this.onp_colonnes_transfert = client.details.var.onp_colonnes_transfert || [];
			this.onp_colonnes_reprise_siret = client.details.var.onp_colonnes_reprise_siret || [];

            if (!(response.client.details && client.details.pages && client.details.pages.phar_excel_validate_onp))
            {
                this.$router.push({ name: "profile" });
			}

			this.project = client.details.pages.phar_excel_validate_onp;
			
			var codes_postal = await database.get("select", "update_table", {
				select: "code_postal",
				where: "status = 'créé' group by code_postal order by code_postal"
			});

			for (var i = 0; i < codes_postal.length; i++)
			{
				this.codes_postal.push(codes_postal[i].code_postal);
			}

			if (this.codes_postal.length > 0)
			{	
				this.code_postal = this.codes_postal[0];
				this.set()
			}
		},
	};
</script>
